export const awardsData = [
  {
    "id": 1,
    "year": "Since 2022",
    "title": "Global Initiative on Polarization (IFIT) and Member of the Depolarization Community of Practitioners"
  },
  {
    "id": 2,
    "year": "2023-2026",
    "title": "Ford Foundation Grant on Polarization Mitigation through Social and Environmental Justice in Indonesia"
  },
  {
    "id": 3,
    "year": "2024-2025",
    "title": "Partnership for Religion and Sustainable Development (PaRD), Joint Learning Initiative (JLI) and World Vision (WV) on Strategic Religious Engagement on Ecology, Sustainability, Conservation in Indonesia"
  },
  {
    "id": 4,
    "year": "2023-2025",
    "title": "Indonesian Institute for Academic Partnerships (IIAP) Grant on \u201cReligious Literacy to Promote Multiculturalism and Social Justice\u201d"
  },
  {
    "id": 5,
    "year": "2022-2025",
    "title": "Teaching Young Fellows\u2019 Scholarship on \u201cReligion and Rule of Law\u201d, Christchurch, Oxford University, UK"
  },
  {
    "id": 6,
    "year": "2020-2025",
    "title": "Human Dignity in Religious Traditions (HDRT) with Brigham Young University and Baylor University"
  },
  {
    "id": 7,
    "year": "2021-2024",
    "title": "Templeton Foundation on \u201cEco-Pesantren and the Teaching of Science in Islamic Schools\u201d"
  },
  {
    "id": 8,
    "year": "2018-2021",
    "title": "Ford Foundation Grant on \u201cCo-Designing Sustainable, Just and Smart Urban Living in Indonesia\u201d"
  },
  {
    "id": 9,
    "year": "2018-2019",
    "title": "Netherlands Embassy Grant on \u201cReligious Freedom and Harmony\u201d"
  },
  {
    "id": 10,
    "year": "2017-2020",
    "title": "British Council Grant on \u201cReligious Literacy in Indonesia\u201d"
  },
  {
    "id": 11,
    "year": "2017",
    "title": "European Union Visitor\u2019s Program (EUVP) to Brussels, Belgium"
  },
  {
    "id": 12,
    "year": "2017",
    "title": "Erasmus+ Visiting Professorship at Sofia University, Bulgaria"
  },
  {
    "id": 13,
    "year": "2017",
    "title": "British Council Grant to British Association for Islamic Studies (BRAIS)"
  },
  {
    "id": 14,
    "year": "2016",
    "title": "Ford Foundation on \u201cThe Shi\u2019as of Nusantara: Islamic Diffusion and Diversity in Indonesia\u201d"
  },
  {
    "id": 15,
    "year": "2014-2015",
    "title": "US State Department on \u201cIndonesian Interfaith Weather Station (IIWS)\u201d"
  },
  {
    "id": 16,
    "year": "2013-2017",
    "title": "Henry Luce Foundation on \u201cReligion, Public Policy and Social Transformation in Southeast Asia\u201d"
  },
  {
    "id": 17,
    "year": "2013-2014",
    "title": "The Nippon Foundation\u2019s Asian Public Intellectuals (API) Collaborative Research Project on \u201cPolicy Brokering on Sustainability Transition in Five Communities in Asia\u201d"
  },
  {
    "id": 18,
    "year": "2013",
    "title": "Globethics on \u201cReligion and Television in Indonesia\u201d"
  },
  {
    "id": 19,
    "year": "2012-2013",
    "title": "Henry Luce Foundation on Planning Workshops for \u201cEngaging Southeast Asia: Religion, Foreign Policy and Public Affairs\u201d"
  },
  {
    "id": 20,
    "year": "2012",
    "title": "Catholic Organization for Relief and Development Aid (Cordaid) on \u201cReligion and Gender in Indonesia\u201d"
  },
  {
    "id": 21,
    "year": "2008-2012",
    "title": "The Nippon Foundation\u2019s API Regional Project on \u201cCommunity-Based Initiatives toward Human-Ecological Balance\u201d"
  },
  {
    "id": 22,
    "year": "2007-2008",
    "title": "API Fellowship by The Nippon Foundation and Indonesian Institute of Sciences (LIPI) on \u201cInklings of Progressive Islam in Malaysia\u201d"
  },
  {
    "id": 23,
    "year": "2003",
    "title": "National University of Singapore (NUS) Dissertation Research Travel Grant to Iran and Indonesia"
  },
  {
    "id": 24,
    "year": "2001-2004",
    "title": "National University of Singapore (NUS) Research Scholarship"
  },
  {
    "id": 25,
    "year": "1999-2001",
    "title": "J. William Fulbright Award (United States Information Agency)"
  },
  {
    "id": 26,
    "year": "1998-1999",
    "title": "Sultan of Brunei Darussalam ASEAN Scholarship"
  },
  {
    "id": 27,
    "year": "1998",
    "title": "Istituto per il Commercio con l\u2019Estero (Italian Institute for Foreign Trade)"
  },
  {
    "id": 28,
    "year": "1997",
    "title": "Chevenings Award (British Foreign and Commonwealth Office)"
  },
  {
    "id": 29,
    "year": "1995",
    "title": "ASEAN Visiting Fellowship (Singapore International Foundation)"
  }
];
